// extracted by mini-css-extract-plugin
module.exports = {"modal":"ModalContainer_modal__257FZ","title":"ModalContainer_title__1E-hR","description":"ModalContainer_description__3axEm"};